import "flatpickr/dist/themes/material_blue.css";
import { useDetailReport } from "hook/invoices/useReport";
import { PATH_TYPE_REPORT } from "pages/ReportInvoiceError/helper/functionHelper";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { Progress } from "reactstrap";
import {
  downloadReportInvoice,
  getReportInvoiceProgress,
  resetDownloadReportInvoice,
  resetGetReportInvoiceProgress,
} from "store/summary-invoice-data/actions";
import {
  DOWNLOAD_REPORT_INVOICE_FAIL,
  DOWNLOAD_REPORT_INVOICE_SUCCESS,
} from "store/summary-invoice-data/actionTypes";

const ProgressExport = props => {
  const {
    funcComplete,
    idReport,
    fileName,
    typeReportProgress = undefined,
  } = props;
  const dispatch = useDispatch();
  const [isDownload, setIsDownload] = useState(false);
  // store reducer
  const summaryInvoiceData = useSelector(state => state.summaryInvoiceData);
  const { reportInvoiceProgress, type: typeReport } = summaryInvoiceData;

  const { type, fileDownload, fileDownloadName, loadingDownload } =
    summaryInvoiceData;
  const { addToast } = useToasts();

  useEffect(() => {
    switch (typeReport) {
      case DOWNLOAD_REPORT_INVOICE_SUCCESS: {
        if (fileDownload !== null) {
          const link = document.createElement("a");
          link.href = fileDownload;
          link.setAttribute("download", fileDownloadName);
          document.body.appendChild(link);
          link.click();
        }
        addToast("Tải xuống thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(resetDownloadReportInvoice());
        if (funcComplete) {
          funcComplete();
        }
        break;
      }
      case DOWNLOAD_REPORT_INVOICE_FAIL:
        addToast("Tải xuống thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetDownloadReportInvoice());
        break;
    }
  }, [typeReport]);

  useEffect(() => {
    if (idReport) {
      console.log("🚀 ~ 0. Get Report Progress", {
        idReport,
        typeReportProgress,
      });
      // if (!reportInvoiceProgress?.id) {
      dispatch(getReportInvoiceProgress(idReport, true, typeReportProgress));
      // }
    }
  }, [idReport]);

  useEffect(() => {
    if (reportInvoiceProgress?.percent === 100) {
      console.log("🚀 ~ 1. Report Progress 100% -> Get Detail Report");
      setIsDownload(true);
    }
  }, [reportInvoiceProgress]);

  const { mutate, data: dataDetailReport } = useDetailReport(() => {});

  useEffect(() => {
    if (dataDetailReport) {
      if (dataDetailReport?.auth_status === "A") {
        console.log("🚀 ~ 3. Detail Report Complete -> Download Report", {
          idReport,
          fileName,
          typeReportProgress,
        });
        dispatch(
          downloadReportInvoice(
            idReport,
            fileName,
            "blob",
            PATH_TYPE_REPORT.EXCEL,
            typeReportProgress
          )
        );
      } else if (dataDetailReport?.auth_status === "R") {
        console.log("🚀 ~ 3. Detail Report Reject -> Show Modal Error");
      } else {
        setTimeout(() => {
          mutate({ id: idReport, typeReport: typeReportProgress });
        }, 3000);
      }
    }
  }, [dataDetailReport]);

  useEffect(() => {
    if (isDownload) {
      console.log("🚀 ~ 2.Get Detail Report", { idReport, typeReportProgress });
      mutate({ id: idReport, typeReport: typeReportProgress });
    }
  }, [isDownload]);

  useEffect(() => {
    return () => {
      console.log("🚀 ~ 4. Reset Report Progress");
      setIsDownload(false);
      dispatch(resetGetReportInvoiceProgress());
    };
  }, []);

  return (
    <React.Fragment>
      <div className="ProgressExport justify-content-center d-flex mt-1 mb-2 gap-2">
        <div style={{ width: "50vw" }}>
          <div
            className="d-flex justify-content-center align-items-end gap-2"
            style={{ fontSize: "13px" }}
          >
            {/* <i className=" far fa-file-excel text-success font-size-20" /> */}
            {/* <strong>{nameFile + ".xlsx "}</strong> */}
            {reportInvoiceProgress.percent === 100 ? "" : "(Đang xuất dữ liệu)"}
          </div>
          <Progress
            style={{ height: "33px" }}
            animated
            color={`${
              reportInvoiceProgress.percent === 100 ? "success" : "warning"
            }`}
            striped
            value={reportInvoiceProgress.percent}
          >
            <span style={{ fontSize: "13px" }}>
              {reportInvoiceProgress.percent === 100 &&
                "Hệ thống đang lưu trữ báo cáo "}{" "}
              ({reportInvoiceProgress.percent + "%"})
            </span>
          </Progress>
        </div>
        <div
          style={{
            display: "flex",
            gap: "15px",
            justifyContent: "center",
            fontSize: "13px",
            marginTop: "10px",
            lineHeight: "15px",
            alignItems: "center",
          }}
        >
          {/* <div className="text-primary">Id Report: {idReport}</div> */}
          {/* {getTimeContent(dataDetail?.parameters) && (
                  <div className="text-info">
                    Thời gian thống kê: {getTimeContent(dataDetail?.parameters)}
                  </div>
                )} */}
        </div>
        {/* {reportInvoiceProgress?.percent === 100 && (
          <Button
            color="success"
            className="btn"
            type="button"
            disabled={reportInvoiceProgress?.percent !== 100 || loadingDownload}
            onClick={() => {
              dispatch(
                downloadReportInvoice(
                  idReport,
                  fileName,
                  //   +
                  //     getTimeContent(dataDetail.parameters)
                  "blob",
                  PATH_TYPE_REPORT.EXCEL
                )
              );
            }}
          >
            <i
              className={` ${
                loadingDownload ? "bx bx-loader bx-spin " : "bx bx-download "
              } label-icon`}
              style={{
                background: "transparent",
              }}
            ></i>
          </Button>
        )} */}
      </div>
    </React.Fragment>
  );
};

ProgressExport.propTypes = {
  funcComplete: PropTypes.any,
  idReport: PropTypes.any,
  fileName: PropTypes.any,
  t: PropTypes.any,
  typeReportProgress: PropTypes.any,
};

ProgressExport.defaultProps = {};

export default ProgressExport;
